import api from '.'

export async function deletePermission(id: string): Promise<void> {
  await api.delete(`/${id}`)
}
